// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powerbi-security-container {
  padding: 20px;
}

.powerbi-security-container .card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.powerbi-security-container .card-body {
  padding: 1.5rem;
}

.powerbi-security-container .table thead th {
  background-color: var(--color-bg-hover);
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  padding: 12px;
}

.powerbi-security-container .table tbody td {
  vertical-align: middle;
  padding: 12px;
}

.powerbi-security-container .table tbody tr:hover {
  background-color: var(--color-bg-hover);
}

.powerbi-security-container code {
  background-color: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #495057;
}

.powerbi-security-form-container {
  padding: 20px;
}

.powerbi-security-form-container .card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.powerbi-security-form-container .card-header {
  background-color: var(--color-bg-hover);
  border-bottom: 2px solid #dee2e6;
  padding: 1rem 1.5rem;
}

.powerbi-security-form-container .form-check-simple {
  display: inline-flex;
  align-items: center;
}

.powerbi-security-form-container .form-check-input {
  cursor: pointer;
}

.powerbi-security-form-container .form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.powerbi-security-form-container .form-check-label {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
  margin-bottom: 0;
}

.btn-outline-primary:hover {
  color: var(--color-white);
  background-color: var(--color-link-blue);
  border-color: var(--color-link-blue);
}

.btn-outline-danger:hover {
  color: var(--color-white);
  background-color: #dc3545;
  border-color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-security/components/PowerBISecurity.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".powerbi-security-container {\r\n  padding: 20px;\r\n}\r\n\r\n.powerbi-security-container .card {\r\n  border: none;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n}\r\n\r\n.powerbi-security-container .card-body {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.powerbi-security-container .table thead th {\r\n  background-color: var(--color-bg-hover);\r\n  font-weight: 600;\r\n  border-bottom: 2px solid #dee2e6;\r\n  padding: 12px;\r\n}\r\n\r\n.powerbi-security-container .table tbody td {\r\n  vertical-align: middle;\r\n  padding: 12px;\r\n}\r\n\r\n.powerbi-security-container .table tbody tr:hover {\r\n  background-color: var(--color-bg-hover);\r\n}\r\n\r\n.powerbi-security-container code {\r\n  background-color: #e9ecef;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  color: #495057;\r\n}\r\n\r\n.powerbi-security-form-container {\r\n  padding: 20px;\r\n}\r\n\r\n.powerbi-security-form-container .card {\r\n  border: none;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n}\r\n\r\n.powerbi-security-form-container .card-header {\r\n  background-color: var(--color-bg-hover);\r\n  border-bottom: 2px solid #dee2e6;\r\n  padding: 1rem 1.5rem;\r\n}\r\n\r\n.powerbi-security-form-container .form-check-simple {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.powerbi-security-form-container .form-check-input {\r\n  cursor: pointer;\r\n}\r\n\r\n.powerbi-security-form-container .form-check-input:checked {\r\n  background-color: #28a745;\r\n  border-color: #28a745;\r\n}\r\n\r\n.powerbi-security-form-container .form-check-label {\r\n  cursor: pointer;\r\n  user-select: none;\r\n  font-weight: 500;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  color: var(--color-white);\r\n  background-color: var(--color-link-blue);\r\n  border-color: var(--color-link-blue);\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n  color: var(--color-white);\r\n  background-color: #dc3545;\r\n  border-color: #dc3545;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
